__turbopack_context__.v({
  "AmosAir": "Menu-module-sass-module__NPqu6W__AmosAir",
  "Backdrop": "Menu-module-sass-module__NPqu6W__Backdrop",
  "Button": "Menu-module-sass-module__NPqu6W__Button",
  "HeaderBg": "Menu-module-sass-module__NPqu6W__HeaderBg",
  "HydroIndustries": "Menu-module-sass-module__NPqu6W__HydroIndustries",
  "LongSubmenu": "Menu-module-sass-module__NPqu6W__LongSubmenu",
  "Menu": "Menu-module-sass-module__NPqu6W__Menu",
  "Open": "Menu-module-sass-module__NPqu6W__Open",
  "Submenu": "Menu-module-sass-module__NPqu6W__Submenu",
  "SubmenuCta": "Menu-module-sass-module__NPqu6W__SubmenuCta",
  "SubmenuCtaImage": "Menu-module-sass-module__NPqu6W__SubmenuCtaImage",
  "WhatWeDo": "Menu-module-sass-module__NPqu6W__WhatWeDo",
});
